import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
} from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { SelectComponent } from '../../select/select.component';
import { FilterOption, PageChangeDirection } from '../table.interface';
import { TableContext } from '../../../services/table/table-context.service';
import {
  DictionaryService,
  language,
} from '../../../services/dictionary.service';

@Component({
  selector: 'app-table-footer',
  imports: [NgIcon, SelectComponent],
  templateUrl: './table-footer.component.html',
  styleUrl: './table-footer.component.scss',
})
export class TableFooterComponent {
  // Inject Service
  tableContext = inject(TableContext);
  private cdr = inject(ChangeDetectorRef);
  dictionaryService = inject(DictionaryService);

  private timeout: ReturnType<typeof setTimeout> | undefined = undefined;
  language: language = this.dictionaryService.language;
  constructor() {
    effect(() => {
      // We read the values so the effect registers them as dependencies
      const _p = this.tableContext.pages();
      const _c = this.tableContext.page();
      const _rows = this.tableContext.tableData().rows.length;

      this.language = this.dictionaryService.language;

      // Force Angular to check the view for updates
      this.cdr.markForCheck();
    });
  }

  // Helpers
  handleChangePageSize = (count: string) => {
    this.tableContext.updatePageSize(+count);
  };

  setPage = (action: PageChangeDirection) => {
    if (action === 'forward') {
      this.tableContext.setPage(this.tableContext.page() + 1);
    } else {
      this.tableContext.setPage(this.tableContext.page() - 1);
    }

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.tableContext.updateCurrentPage(this.tableContext.page());
    }, 500);
  };
}
